import type { PointerEvent } from "react";

import { Button } from "@virtual-brain-lib/frontend-design-system/ui";
import { cn } from "@virtual-brain-lib/frontend-design-system/utils";

interface ScrollToBottomButtonProps {
	readonly isAtBottom: boolean;
	readonly onClick: () => void;
	readonly id?: string | undefined;
	readonly className?: string | undefined;
}

export default function ScrollToBottomButton({
	isAtBottom,
	onClick,
	id,
	className,
}: ScrollToBottomButtonProps) {
	function handlePointerDown(e: PointerEvent) {
		e.preventDefault();
		onClick();
	}

	return (
		<Button
			leftIcon="arrowDown"
			id={id}
			className={cn(
				"absolute bottom-4 left-1/2 -translate-x-1/2 rounded-full transition-opacity duration-100 motion-reduce:duration-0",
				isAtBottom ? "pointer-events-none opacity-0" : "pointer-events-auto opacity-100",
				className,
			)}
			onPointerDown={handlePointerDown}
		/>
	);
}
